import type { ChannelType } from "../enums/ChannelTypeEnum"
import type { ChannelStatus } from "../enums/ChannelStatusEnum"
import type { ChannelItemType } from "../enums/ChannelItemTypeEnum"
import type { AppServiceType } from "../enums/AppServiceTypeEnum"


export class ChannelFilterEntity {
  id?: number | undefined
  name?: string
  searchWord?: string
  page?: number
  sortField?: string
  sortDescending?: boolean
  limit?: number
  type?: ChannelType
  status?: ChannelStatus
  itemType?: ChannelItemType
  appServiceType?: AppServiceType
}

 